/**
 * The bar that was missing (#1323).
 *
 * Joe, walking the live app: "where is the back or next button?" There was
 * none. Every screen had been built as a step in a first-run funnel and nobody
 * wired the app together afterwards — once you landed on the plan, the only way
 * out was the URL bar.
 *
 * Bottom bar rather than a sidebar because this is a phone held over a counter,
 * and the thumb is at the bottom of it.
 */
import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/plan", label: "Plan" },
  { to: "/deck", label: "Deck" },
  // ⚠️ Beside the deck, not instead of it. The deck decides, the cookbook
  // browses, and collapsing the two would turn three swipes into a wall of
  // thirty-six choices nobody finishes.
  { to: "/cookbook", label: "Cookbook" },
  { to: "/kitchen", label: "Kitchen" },
];

export function Nav() {
  return (
    <nav
      aria-label="Main"
      // Sits above the home indicator on a phone, and the page below reserves
      // room for it so the last row of a shopping list is never trapped under it.
      className="bg-ground border-line fixed inset-x-0 bottom-0 z-10 border-t pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="mx-auto flex max-w-md">
        {TABS.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              className="tap flex items-center justify-center text-sm font-medium"
              style={({ isActive }) => ({
                color: isActive ? "var(--color-plate-b)" : "var(--color-muted)",
                boxShadow: isActive ? "inset 0 2px 0 var(--color-plate-b)" : "none",
              })}
            >
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
